import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
// @ts-ignore
import TableActions from 'components/TableActions';
// @ts-ignore
import EntityNames from 'scenes/Workforce/scenes/Groups/components/GroupsTable/components/GroupsTableRow/components/EntityNames';
// @ts-ignore
import GroupName from 'components/GroupName';
// @ts-ignore
import RoleButtonLink from 'components/RoleButtonLink';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
// @ts-ignore
import RoleTableRowLink from 'components/RoleTableRowLink';

// @ts-ignore
import GroupsPeopleList from './components/GroupsPeopleList';

// Child Components
// @ts-ignore
import GroupDuplicateLink from './components/GroupDuplicateLink';

interface Props {
    groupId?: number;
}

export default class GroupsTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { groupId } = this.props;
        if (!groupId) {
            return null;
        }
        return (
            <RoleTableRowLink
                params={{
                    selectedGroup: groupId,
                    groupModal: true
                }}
                requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
            >
                <Table.Cell>
                    <GroupName groupId={groupId} />
                </Table.Cell>
                <Table.Cell
                    style={{
                        maxWidth: '250px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                >
                    <GroupsPeopleList groupId={groupId} />
                </Table.Cell>
                <Table.Cell>
                    <EntityNames groupId={groupId} />
                </Table.Cell>
                <Table.Cell textAlign="right">
                    <TableActions>
                        <RoleButtonLink
                            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                            params={{
                                selectedGroup: groupId,
                                groupModal: true
                            }}
                        >
                            Edit
                        </RoleButtonLink>
                        <RoleGate
                            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                        >
                            <GroupDuplicateLink groupId={groupId} />
                        </RoleGate>
                        <RoleGate
                            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                        >
                            <RoleButtonLink
                                requiredRoles={[
                                    ADMIN,
                                    MANAGER,
                                    ASSISTANT_MANAGER
                                ]}
                                params={{
                                    selectedGroup: groupId,
                                    groupDeleteModal: true
                                }}
                            >
                                Delete
                            </RoleButtonLink>
                        </RoleGate>
                    </TableActions>
                </Table.Cell>
            </RoleTableRowLink>
        );
    }
}
